import { render, staticRenderFns } from "./SummaryBalance.vue?vue&type=template&id=224f7172&scoped=true"
import script from "./SummaryBalance.vue?vue&type=script&lang=ts"
export * from "./SummaryBalance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224f7172",
  null
  
)

export default component.exports